/**
 * Generic Column Settings Button
 * Trigger button to open column settings modal
 */

import IconTable from 'src/assets/images/icons/grid-7.svg';

interface ColumnSettingsButtonProps {
  onClick: () => void;
  label?: string;
  id?: string;
}

export const ColumnSettingsButton = ({ onClick, label = 'Columns', id }: ColumnSettingsButtonProps) => (
  <button
    type='button'
    onClick={onClick}
    className='inline-flex items-center gap-8 bg-[#E6F6EC] text-[#00A651] rounded-8 px-12 py-8 text-14 font-bold hover:bg-[#d1f0db] transition-colors'
    aria-label='Open column settings'
    id={id}
  >
    <span>{label}</span>
    <img src={IconTable} alt='' />
  </button>
);
